import React from 'react';

import RecommendationStructuredView from './RecommendationStructuredView';
import { AIInsightSolution } from '../../types/recommendations';

type Props = {
  structure: AIInsightSolution;
};

const RecommendationCompanyStructured = ({ structure }: Props) => {
  return <RecommendationStructuredView structure={structure} />;
};

export default RecommendationCompanyStructured;
